// status
export const STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  DISABLED: 'disabled',
};
